export enum ModalTypeEnum {
  RATING = 'rating',
  QUESTION = 'question',
  BOOKING = 'booking',
  CUSTOM_BOOKING = 'custom-booking',
  UPDATE_INFO = 'update-info',
  DOKTORSE_RECEPT = 'doktorse-recept',
  MAILCHIMP = 'mailchimp',
  BECOME_CUSTOMER = 'become-customer',
  // LISTA_DIG_HSA = 'lista-dig-hsa',
  INFO = 'info-modal',
  // LISTA_DIG_IFRAME = 'lista-dig-iframe',
  // LISTA_DIG_VARDEN = 'lista-dig-varden',
  GOOGLE_MAP = 'google-map',
  // LISTA_DIG_DIRECT = 'lista-dig-direct',
  // ARE_YOU_LISTED = 'are-you-listed',
  CUSTOMER_RATING = 'customer-rating',
  VARDEN_BOOKING_CONFIRMATION_V2 = 'varden-booking-confirmation-v2',
  TREATMENT_DETAILS = 'treatment-details',
  MESSAGE = 'message',
  GALLERY = 'gallery',
}
